import { baseApi, apiTags } from "../baseApi";
import type { Contact, SetContactArchivedParams } from "../types/api.types";

export const contactsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getContacts: builder.query<Contact[], void>({
            query: () => ({
                resource: "crm-contact",
                action: "index",
                method: "GET",
                queryBuilder: (query: any) => {
                    return query.with("requisite").with("requisite_bank").with("files");
                },
            }),
            providesTags: (result) =>
                result && Array.isArray(result)
                    ? [
                          { type: apiTags.Contact, id: "LIST" },
                          ...result.map((item) => ({ type: apiTags.Contact, id: item.id })),
                      ]
                    : [{ type: apiTags.Contact, id: "LIST" }],
        }),
        getContactById: builder.query<Contact, number>({
            query: (id) => ({
                resource: "crm-contact",
                action: "index",
                method: "GET",
                id: id,
                queryBuilder: (query: any) => {
                    return query
                        .where("id", id)
                        .with("requisite")
                        .with("requisite_bank")
                        .with("files")
                        .first();
                },
            }),
            providesTags: (result, error, arg) =>
                result ? [{ type: apiTags.Contact, id: arg }] : [],
        }),
        setContactArchived: builder.mutation<Contact, SetContactArchivedParams>({
            query: ({ contactId, isArchived, refuseReasonId = 1 }) => ({
                resource: "crm-contact",
                action: "archive",
                method: "PUT",
                id: contactId,
                data: {
                    is_archive: isArchived,
                    refuse_reason_id: isArchived !== 0 ? refuseReasonId : null,
                },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: apiTags.Contact, id: arg.contactId },
                { type: apiTags.Contact, id: "LIST" },
            ],
        }),
    }),
});

export const { useGetContactsQuery, useGetContactByIdQuery, useSetContactArchivedMutation } =
    contactsApi;
